(() => {
  if (window.__synergyGiftChoiceReady) return;
  window.__synergyGiftChoiceReady = true;

  const GIFT_PROP = '_synergy_free_gift';
  const LABEL_PROP = '_synergy_gift_label';
  const STORAGE_KEY = 'synergy_free_ball_variant_v2';
  const GIFTS = [
    { id: 46995267551478, label: 'Green', css: 'green' },
    { id: 46995267485942, label: 'Pink', css: 'pink' },
    { id: 46995267518710, label: 'Yellow', css: 'yellow' }
  ];
  const GIFT_IDS = new Set(GIFTS.map(x => x.id));
  const QUALIFYING = new Set([
    46994686935286,46994721341686,46995110658294,46995125240054,
    46995148275958,46998351839478,46998980264182,46995181076726,
    46995181011190
  ]);

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const parser = new DOMParser();
  let syncing = false;
  let choosing = false;
  let queued = false;
  let timer = null;
  let latestCart = null;
  let preferred = null;
  let bubbleObserver = null;
  let suppressBubble = false;

  const option = id => GIFTS.find(x => x.id === Number(id));
  const onCartPage = () => !!document.getElementById('main-cart-items');
  const saved = () => {
    try { return option(localStorage.getItem(STORAGE_KEY)); } catch (_) { return null; }
  };
  const save = id => {
    try { localStorage.setItem(STORAGE_KEY, String(id)); } catch (_) {}
  };
  const qualifyingQty = cart => (cart.items || []).reduce(
    (n, item) => n + (QUALIFYING.has(Number(item.variant_id)) ? Number(item.quantity || 0) : 0), 0
  );
  const isGift = item => GIFT_IDS.has(Number(item.variant_id)) && (
    String(item.properties?.[GIFT_PROP]) === 'true' ||
    Number(item.final_line_price ?? item.final_price) === 0
  );
  const giftLines = cart => (cart.items || []).filter(isGift);
  const fetchCart = () => fetch(root + 'cart.js', { credentials:'same-origin', cache:'no-store' }).then(r => r.json());
  const selected = () => option(preferred) || saved();

  function cartSections() {
    if (onCartPage()) {
      const items = document.getElementById('main-cart-items')?.dataset.id;
      const footer = document.getElementById('main-cart-footer')?.dataset.id;
      return [items,'cart-icon-bubble','cart-live-region-text',footer].filter(Boolean);
    }
    const target = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (target?.getSectionsToRender) return target.getSectionsToRender().map(x => x.id);
    return ['cart-drawer','cart-icon-bubble'];
  }

  function replaceBySelector(html, currentSelector, responseSelector = currentSelector) {
    if (!html) return false;
    const current = document.querySelector(currentSelector);
    const replacement = parser.parseFromString(html,'text/html').querySelector(responseSelector);
    if (!current || !replacement) return false;
    current.innerHTML = replacement.innerHTML;
    return true;
  }

  function replaceById(html, id) {
    if (!html) return false;
    const doc = parser.parseFromString(html,'text/html');
    const current = document.getElementById(id);
    const replacement = doc.getElementById(id);
    if (!current || !replacement) return false;
    current.innerHTML = replacement.innerHTML;
    return true;
  }

  function updateBubble(html) {
    if (!html) return;
    suppressBubble = true;
    try {
      if (!replaceById(html,'cart-icon-bubble')) {
        replaceBySelector(html,'#cart-icon-bubble','.shopify-section');
      }
    } finally {
      setTimeout(() => { suppressBubble = false; }, 0);
    }
  }

  function refreshCartPage(payload) {
    if (!payload?.sections) return;
    const itemSection = document.getElementById('main-cart-items')?.dataset.id;
    const footerSection = document.getElementById('main-cart-footer')?.dataset.id;

    if (itemSection && payload.sections[itemSection]) {
      replaceBySelector(payload.sections[itemSection],'#main-cart-items .js-contents','.js-contents');
    }
    if (footerSection && payload.sections[footerSection]) {
      replaceBySelector(payload.sections[footerSection],'#main-cart-footer .js-contents','.js-contents');
    }
    updateBubble(payload.sections['cart-icon-bubble']);
    if (payload.sections['cart-live-region-text']) {
      replaceById(payload.sections['cart-live-region-text'],'cart-live-region-text');
    }
    document.dispatchEvent(new CustomEvent('synergy:cart-rendered'));
  }

  function refreshUI(payload) {
    if (!payload?.sections) return;

    if (onCartPage()) {
      refreshCartPage(payload);
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.classList.contains('active')) {
      replaceById(payload.sections['cart-drawer'],'CartDrawer');
      updateBubble(payload.sections['cart-icon-bubble']);
      drawer.classList.remove('is-empty');
      drawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
      document.dispatchEvent(new CustomEvent('synergy:cart-rendered'));
      observeBubble();
      return;
    }

    const target = drawer || document.querySelector('cart-notification');
    if (target?.renderContents) {
      try {
        target.renderContents(payload);
        document.dispatchEvent(new CustomEvent('synergy:cart-rendered'));
      } catch (e) {
        console.warn('Synergy cart UI refresh skipped', e);
      }
    }
  }

  async function changeLine(key, quantity, render = false) {
    const body = { id:key, quantity };
    if (render) {
      body.sections = cartSections();
      body.sections_url = location.pathname;
    }
    return fetch(root + 'cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      credentials:'same-origin',
      body:JSON.stringify(body)
    }).then(r => r.json());
  }

  async function addGift(id, quantity) {
    const x = option(id);
    if (!x || quantity < 1) return null;
    const fd = new FormData();
    fd.append('id',String(x.id));
    fd.append('quantity',String(quantity));
    fd.append(`properties[${GIFT_PROP}]`,'true');
    fd.append(`properties[${LABEL_PROP}]`,`FREE 4-Pack — ${x.label}`);
    fd.append('sections',cartSections().join(','));
    fd.append('sections_url',location.pathname);
    return fetch(root + 'cart/add.js', {
      method:'POST',
      headers:{'X-Requested-With':'XMLHttpRequest'},
      credentials:'same-origin',
      body:fd
    }).then(r => r.json());
  }

  function ensurePdpSelector() {
    if (!document.documentElement.classList.contains('synergy-premium-paddle-page')) return;
    if (document.querySelector('[data-synergy-pdp-ball-choice]')) return;
    const anchor = document.querySelector('.synergy-premium-benefit');
    if (!anchor) return;
    const box = document.createElement('div');
    box.className = 'synergy-free-ball-choice synergy-pdp-ball-choice';
    box.dataset.synergyPdpBallChoice = '';
    box.setAttribute('role','group');
    box.setAttribute('aria-label','Choose your free pickleball color');
    box.innerHTML = `
      <p class="synergy-free-ball-choice__eyebrow">Choose your free 4-pack</p>
      <p class="synergy-free-ball-choice__title"><strong>Select your ball color</strong></p>
      <p class="synergy-free-ball-choice__meta">Included at no charge with your paddle. Choose before adding to cart.</p>
      <div class="synergy-ball-options">${GIFTS.map(x => `
        <button type="button" class="synergy-ball-option" data-synergy-gift-variant="${x.id}" aria-pressed="false">
          <span class="synergy-ball-option__swatch synergy-ball-option__swatch--${x.css}" aria-hidden="true"></span>
          <span>${x.label}</span>
        </button>`).join('')}</div>
      <p class="synergy-free-ball-choice__status" data-synergy-pdp-ball-status aria-live="polite">Choose Green, Pink, or Yellow before adding your paddle.</p>`;
    anchor.insertAdjacentElement('afterend',box);
  }

  function renderPdp() {
    ensurePdpSelector();
    const choice = selected();
    document.querySelectorAll('[data-synergy-pdp-ball-choice]').forEach(box => {
      box.querySelectorAll('[data-synergy-gift-variant]').forEach(btn => {
        btn.setAttribute('aria-pressed',choice && Number(btn.dataset.synergyGiftVariant) === choice.id ? 'true' : 'false');
      });
      const status = box.querySelector('[data-synergy-pdp-ball-status]');
      if (status) status.textContent = choice
        ? `${choice.label} selected — included FREE with your paddle.`
        : 'Choose Green, Pink, or Yellow before adding your paddle.';
      if (choice) box.classList.remove('is-attention');
    });
  }

  function cartChoiceMarkup(choice, qty) {
    const title = choice
      ? `<strong>FREE 4-Pack included</strong> · ${choice.label} selected`
      : '<strong>FREE 4-Pack included</strong> · Choose your color';
    return `<div class="synergy-free-ball-choice" data-synergy-free-ball-choice role="group" aria-label="Free pickleball color">
      <p class="synergy-free-ball-choice__title">${title}</p>
      <p class="synergy-free-ball-choice__meta">${choice ? 'Change color if you prefer:' : 'Select Green, Pink, or Yellow:'}</p>
      <div class="synergy-ball-options">${GIFTS.map(x => `
        <button type="button" class="synergy-ball-option" data-synergy-gift-variant="${x.id}" aria-pressed="${choice?.id === x.id ? 'true' : 'false'}"${choosing ? ' disabled' : ''}>
          <span class="synergy-ball-option__swatch synergy-ball-option__swatch--${x.css}" aria-hidden="true"></span><span>${x.label}</span>
        </button>`).join('')}</div>
      <span class="visually-hidden">${qty} free 4-pack${qty > 1 ? 's' : ''} included at no charge.</span>
    </div>`;
  }

  function renderCart(cart) {
    latestCart = cart;
    const qty = qualifyingQty(cart);
    const choice = selected();

    document.querySelectorAll('.synergy-free-gift-line').forEach(el => el.classList.remove('synergy-free-gift-line'));
    (cart.items || []).forEach((item,i) => {
      if (!isGift(item)) return;
      document.getElementById(`CartDrawer-Item-${i+1}`)?.classList.add('synergy-free-gift-line');
      document.getElementById(`CartItem-${i+1}`)?.classList.add('synergy-free-gift-line');
    });

    if (qty < 1) {
      document.querySelectorAll('[data-synergy-free-ball-choice]').forEach(el => {
        if (!el.matches('[data-synergy-pdp-ball-choice]')) el.remove();
      });
      return;
    }

    const hosts = [
      document.querySelector('cart-drawer .drawer__footer'),
      document.querySelector('main .cart__footer, #main-cart-footer .cart__footer')
    ].filter((x,i,a) => x && a.indexOf(x) === i);

    const state = `${choice?.id || 'none'}:${qty}:${choosing ? 1 : 0}`;
    hosts.forEach(host => {
      const old = host.querySelector('[data-synergy-free-ball-choice]');
      if (old?.dataset.state === state) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = cartChoiceMarkup(choice,qty);
      const fresh = tmp.firstElementChild;
      fresh.dataset.state = state;
      if (old) old.replaceWith(fresh);
      else {
        const before = host.querySelector('[data-synergy-cart-conversion]') || host.querySelector('.cart__ctas');
        before ? host.insertBefore(fresh,before) : host.prepend(fresh);
      }
    });
  }

  async function removeLines(lines, renderLast = false) {
    let payload = null;
    for (let i=0;i<lines.length;i++) {
      const render = renderLast && i === lines.length - 1;
      payload = await changeLine(lines[i].key,0,render);
      if (render) refreshUI(payload);
    }
    return payload;
  }

  async function reconcile(choiceOverride = null) {
    if (syncing || (choosing && !choiceOverride)) { queued = true; return; }
    syncing = true;
    try {
      let cart = await fetchCart();
      const qty = qualifyingQty(cart);
      const gifts = giftLines(cart);
      const choice = choiceOverride || selected();

      if (qty < 1 || !choice) {
        if (gifts.length) {
          await removeLines(gifts,true);
          cart = await fetchCart();
        }
        renderCart(cart);
        return;
      }

      save(choice.id);
      const same = gifts.filter(x => Number(x.variant_id) === choice.id);
      const primary = same[0];
      const remove = gifts.filter(x => Number(x.variant_id) !== choice.id).concat(same.slice(1));
      const add = !primary;
      const resize = !!primary && Number(primary.quantity || 0) !== qty;

      if (remove.length) await removeLines(remove,remove.length > 0 && !add && !resize);

      if (add) refreshUI(await addGift(choice.id,qty));
      else if (resize) refreshUI(await changeLine(primary.key,qty,true));

      if (remove.length || add || resize) cart = await fetchCart();
      renderCart(cart);
    } catch (e) {
      console.warn('Synergy free gift sync skipped',e);
    } finally {
      syncing = false;
      if (queued) { queued = false; schedule(180); }
    }
  }

  async function choose(id) {
    const choice = option(id);
    if (!choice || choosing) return;
    choosing = true;
    preferred = choice.id;
    save(choice.id);
    renderPdp();
    if (latestCart) renderCart(latestCart);
    try { await reconcile(choice); }
    finally {
      choosing = false;
      preferred = null;
      renderPdp();
      if (latestCart) renderCart(latestCart);
      if (queued) { queued = false; schedule(180); }
    }
  }

  function schedule(delay=120) {
    clearTimeout(timer);
    timer = setTimeout(() => reconcile(),delay);
  }

  function observeBubble() {
    if (onCartPage()) {
      bubbleObserver?.disconnect();
      bubbleObserver = null;
      return;
    }
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || bubble.dataset.synergyGiftObserved === 'true') return;
    bubble.dataset.synergyGiftObserved = 'true';
    bubbleObserver?.disconnect();
    bubbleObserver = new MutationObserver(() => {
      if (!suppressBubble && !syncing && !choosing) schedule(140);
    });
    bubbleObserver.observe(bubble,{childList:true,subtree:true,characterData:true});
  }

  window.addEventListener('submit',e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const premiumAdd =
      document.documentElement.classList.contains('synergy-premium-paddle-page') &&
      form.dataset.type === 'add-to-cart-form' &&
      form.closest('product-info[id^="MainProduct-"]');
    if (!premiumAdd || saved()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    ensurePdpSelector();
    const box = document.querySelector('[data-synergy-pdp-ball-choice]');
    box?.classList.add('is-attention');
    const status = box?.querySelector('[data-synergy-pdp-ball-status]');
    if (status) status.textContent = 'Please choose Green, Pink, or Yellow before adding your paddle.';
    box?.scrollIntoView({behavior:'smooth',block:'center'});
  },true);

  document.addEventListener('click',e => {
    const btn = e.target.closest('[data-synergy-gift-variant]');
    if (btn) {
      e.preventDefault();
      choose(Number(btn.dataset.synergyGiftVariant));
      return;
    }
    if (!onCartPage() && e.target.closest('#cart-icon-bubble')) schedule(80);
  });

  function init() {
    renderPdp();
    observeBubble();
    schedule(0);
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule(onCartPage() ? 180 : 140));
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded',init,{once:true})
    : init();
})();